export default {
  state: {
    loadConfig: {
      status: false,
      title: 'load'
    }
  },
  getters: {
    loadConfig(state) {
      return state.loadConfig
    }

  },
  mutations: {
    setLoadConfig(state, loadConfig) {
      state.loadConfig = loadConfig
    },
  },
  actions: {
    loadConfig({
      commit
    }, loadConfig) {
      commit('setLoadConfig', loadConfig);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/loadStore.js